import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";

export default function Notifications() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [msg, setMsg] = useState("");
  const nav = useNavigate();

  const load = () => api.get("/notifications").then(r => { setData(r.data); window.dispatchEvent(new Event("notifications-changed")); });
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); setMsg("Toate marcate ca citite"); setTimeout(()=>setMsg(""),1500); };
  const openNotif = (n) => {
    if (!n.read) api.post(`/notifications/${n.id}/read`).then(() => window.dispatchEvent(new Event("notifications-changed"))).catch(()=>{});
    if (n.link) nav(n.link);
  };

  return (
    <>
      <PageHeader title="Notificări" subtitle={`${data.unread} necitite`}
        actions={data.unread > 0 && <button className="btn btn-secondary" onClick={markAll} data-testid="mark-all-read">Marchează toate ca citite</button>} />
      <Toast msg={msg} type="success" />
      <div style={{ display: "grid", gap: 8 }}>
        {data.items.map(n => (
          <div key={n.id} className="card fade-up" style={{ padding: 16, opacity: n.read ? 0.6 : 1,
            borderLeft: n.read ? "1px solid #E2E8F0" : "3px solid var(--blue-primary)",
            cursor: n.link ? "pointer" : "default" }} data-testid={`notif-${n.id}`}
            onClick={n.link ? () => openNotif(n) : undefined}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: "var(--navy)" }}>
                  {n.title}{n.link && <span style={{ marginLeft: 8, fontSize: 12, color: "var(--blue-primary)" }}>→</span>}
                </div>
                {n.message && <div style={{ fontSize: 13, color: "#334155", marginTop: 3 }}>{n.message}</div>}
                <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 6 }}>
                  {new Date(n.created_at).toLocaleString("ro-RO")}
                  {" · "}<span style={{textTransform:"uppercase",letterSpacing:"0.04em"}}>{n.event}</span>
                </div>
              </div>
              {!n.read && (
                <button className="btn btn-secondary" style={{ padding: "4px 10px", fontSize: 12 }}
                  onClick={(e) => { e.stopPropagation(); markRead(n.id); }} data-testid={`mark-read-${n.id}`}>Marchează ca citit</button>
              )}
            </div>
          </div>
        ))}
        {data.items.length === 0 && <div className="card" style={{ padding: 40, textAlign: "center", color: "#94A3B8" }}>Nicio notificare încă.</div>}
      </div>
    </>
  );
}
